<template>
  <div class="hello">
    <h1 id="montserrat">{{ msg }}</h1>
    <br />
    <br />
    <br />
    <b-container class="bv-example-row">
      <form @submit="register">
        <div class="form-group">
          <strong class="text-left" id="montserrat">Email:</strong>
          <input
            type="email"
            class="form-control"
            v-model="email"
            placeholder
            required
            oninvalid="this.setCustomValidity('Email is required')"
            oninput="setCustomValidity('')"
          />

          <strong class="text-left" id="montserrat">Phone Number:</strong>
          <input
            type="tel"
            class="form-control"
            v-model="phoneNumber"
            placeholder
            required
            oninvalid="this.setCustomValidity('Phone number is required')"
            oninput="setCustomValidity('')"
          />

          <strong class="text-left" id="montserrat">First Name:</strong>
          <input
            type="text"
            class="form-control"
            v-model="firstName"
            placeholder
            required
            oninvalid="this.setCustomValidity('First Name is required')"
            oninput="setCustomValidity('')"
          />

          <strong class="text-left" id="montserrat">Last Name:</strong>
          <input
            type="text"
            class="form-control"
            v-model="lastName"
            placeholder
            required
            oninvalid="this.setCustomValidity('Last Name is required')"
            oninput="setCustomValidity('')"
          />

          <strong class="text-left" id="montserrat">Password:</strong>
          <input
            type="password"
            class="form-control"
            v-model="password"
            placeholder
            required
            oninvalid="this.setCustomValidity('Password is required')"
            oninput="setCustomValidity('')"
          />
        </div>
        <button :disabled="clicked" class="btn btn-primary">Register</button>
      </form>
      <br />
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Register",
  props: {
    msg: String
  },
  data() {
    return {
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      password: "",
      clicked: false
    };
  },
  methods: {
    register(e) {
      this.clicked = true;
      e.preventDefault();
      axios
        .post(process.env.VUE_APP_API_SERVER.concat("/v1/register"), {
          email: this.email,
          phone_number: this.phoneNumber,
          first_name: this.firstName,
          last_name: this.lastName,
          password: this.password
        })
        .then(response => console.log(response.data))
        .catch(error => console.log(error))
        .finally(() => (this.loading = false));
    },
    mounted() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>